var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.step < _vm.screens[_vm.screens.length - 1])?_c('v-btn',{staticClass:"mr-2",attrs:{"small":"","rounded":"","color":"info"},on:{"click":function($event){return _vm.setNextStep()}}},[_vm._v("Continuar")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }